import React, { useMemo, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Joi from "joi-browser";
import { useDispatch } from "react-redux";
import ThankYou from "./ThankYou";
import useForm from "../../hooks/useForm";
import { verifySecurityQuestion } from "../../app/store/auth";

const SecurityQuestion = ({
  handleQuestionBack,
  secQuestion,
  forgotType,
  urlData,
}) => {
  const dispatch = useDispatch();

  const [thankYou, setThankYou] = useState(false);
  const [secMain, setSecMain] = useState(true);

  // Build the schema from the (dynamic) list of security questions.
  const schema = useMemo(() => {
    const builtSchema = {
      // answer: Joi.string().required().label("Security Answer"),
      // confirmAnswer: Joi.string().required().label("Confirm Security Answer"),
      captcha: Joi.string().required().label("Captcha"),
    };
    if (secQuestion !== undefined && secQuestion !== "") {
      secQuestion.forEach((item, key) => {
        builtSchema[`answer_${item.id}`] = Joi.string()
          .required()
          .label(`Answer ${key + 1}`);
      });
    }
    return builtSchema;
  }, [secQuestion]);

  const { data, setData, errors, setErrors, renderInput, validate, handleSubmit } =
    useForm(schema, {});

  const onCaptchaChange = (value) => {
    setData({ ...data, captcha: value });
  };

  const doSubmit = async () => {
    const secAnswer = [];
    secQuestion.forEach((item) => {
      secAnswer.push({
        id: item.id,
        hintAnswer1: data[`answer_${item.id}`],
        type: forgotType,
      });
    });
    const result = await dispatch(verifySecurityQuestion(secAnswer));
    if (result === "success") {
      setSecMain(false);
      setThankYou(true);
    } else {
      const ansId = secQuestion[secQuestion.length - 1].id;
      setErrors({ ...errors, [`answer_${ansId}`]: "Invalid Details" });
    }
  };

  return (
    <React.Fragment>
      {secMain && (
        <div className="row">
          <div className="form-group col-md-12">
            <button className="btn btn-link pl-0" onClick={handleQuestionBack}>
              <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
              Back
            </button>
          </div>
          {secQuestion !== "" &&
            secQuestion !== undefined &&
            secQuestion.map((item, key) => (
              <div className="col-md-12" key={item.id}>
                <label htmlFor="" className="form-control-label">
                  Security Question {key + 1}
                </label>
                <p className="form-control form-group">
                  <b>{item.question1}</b>
                </p>
                {renderInput(
                  `answer_${item.id}`,
                  "Answer " + (key + 1),
                  "password"
                )}
              </div>
            ))}
          {/*
          <div className="col-md-12">
            {renderInput("confirmAnswer", "Confirm Answer", "password")}
          </div> */}
          <div className="col-md-12 form-group">
            <ReCAPTCHA
              sitekey="6Le08xsUAAAAAKC6Oglhe-haRVGzA8KTLUZ-jmEK"
              onChange={onCaptchaChange}
            />
          </div>
          <div className="col-md-12">
            <button
              className="btn btn-outline-default w-100"
              onClick={(e) => handleSubmit(e, doSubmit)}
              disabled={Boolean(validate())}
            >
              SUBMIT
            </button>
          </div>
        </div>
      )}
      {thankYou && (
        <ThankYou forgotType={forgotType} urlData={urlData}></ThankYou>
      )}
    </React.Fragment>
  );
};

export default SecurityQuestion;
